// extracted by mini-css-extract-plugin
export default {"CategoryArea":"Category_CategoryArea__xN7Pu","CategoryItem":"Category_CategoryItem__QI3Su"};